import Vue from 'vue';
import VueI18n from 'vue-i18n';
import frTranslations from './fr';
import enTranslations from './en';
import config from '../config';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: config.locale,
  fallbackLocale: 'fr',
  messages: {
    fr: frTranslations,
    en: enTranslations,
  },
});

export default i18n;
